<template>
  <CFooter>
    <div>
      <a href="https://www.energynortle.pl/" target="_blank">
        ENERGY NORTLE sp. z o.o. sp. k.
      </a>
      <span class="ms-1">
      &copy; {{ new Date().getFullYear() }}
      </span>
    </div>
    <div class="ms-auto">
      <span class="me-1" target="_blank">Powered by</span>
      <a href="https://ddsoft.pl">DDSOFT</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
